var map = {
	"./arrow-up.svg": "./cheops/img/arrow-up.svg",
	"./arrow.svg": "./cheops/img/arrow.svg",
	"./arrow_button.svg": "./cheops/img/arrow_button.svg",
	"./auth_back_arrow.svg": "./cheops/img/auth_back_arrow.svg",
	"./autograde_start_img1.svg": "./cheops/img/autograde_start_img1.svg",
	"./bubble_top.svg": "./cheops/img/bubble_top.svg",
	"./cap.svg": "./cheops/img/cap.svg",
	"./cap_blue.svg": "./cheops/img/cap_blue.svg",
	"./cap_green.svg": "./cheops/img/cap_green.svg",
	"./cap_red.svg": "./cheops/img/cap_red.svg",
	"./certificate_icon.svg": "./cheops/img/certificate_icon.svg",
	"./certificate_stats_icon.svg": "./cheops/img/certificate_stats_icon.svg",
	"./checkmark.svg": "./cheops/img/checkmark.svg",
	"./checkmark_green.svg": "./cheops/img/checkmark_green.svg",
	"./cheops_autograde.svg": "./cheops/img/cheops_autograde.svg",
	"./cheops_logo.svg": "./cheops/img/cheops_logo.svg",
	"./cheops_mechanic.svg": "./cheops/img/cheops_mechanic.svg",
	"./circle.svg": "./cheops/img/circle.svg",
	"./circle_blue.svg": "./cheops/img/circle_blue.svg",
	"./circle_o.svg": "./cheops/img/circle_o.svg",
	"./circle_red.svg": "./cheops/img/circle_red.svg",
	"./clip.svg": "./cheops/img/clip.svg",
	"./clock_icon.svg": "./cheops/img/clock_icon.svg",
	"./close_cross.svg": "./cheops/img/close_cross.svg",
	"./close_cross_black.svg": "./cheops/img/close_cross_black.svg",
	"./clouds.svg": "./cheops/img/clouds.svg",
	"./cluster-logo-corp-small-white.svg": "./cheops/img/cluster-logo-corp-small-white.svg",
	"./cluster-logo-corp-small.svg": "./cheops/img/cluster-logo-corp-small.svg",
	"./cluster-logo-cpm-small-white.svg": "./cheops/img/cluster-logo-cpm-small-white.svg",
	"./cluster-logo-cpm-small.svg": "./cheops/img/cluster-logo-cpm-small.svg",
	"./cluster-logo-sirius-small-white.svg": "./cheops/img/cluster-logo-sirius-small-white.svg",
	"./cluster-logo-sirius-small.svg": "./cheops/img/cluster-logo-sirius-small.svg",
	"./cluster-logo-small-white.svg": "./cheops/img/cluster-logo-small-white.svg",
	"./cluster-logo-small.svg": "./cheops/img/cluster-logo-small.svg",
	"./cluster-logo-textbook-small-white.svg": "./cheops/img/cluster-logo-textbook-small-white.svg",
	"./cluster-logo-textbook-small.svg": "./cheops/img/cluster-logo-textbook-small.svg",
	"./cluster-logo-univ-small-white.svg": "./cheops/img/cluster-logo-univ-small-white.svg",
	"./cluster-logo-univ-small.svg": "./cheops/img/cluster-logo-univ-small.svg",
	"./course-continue-button-arrow.svg": "./cheops/img/course-continue-button-arrow.svg",
	"./course_card_landing_bg.svg": "./cheops/img/course_card_landing_bg.svg",
	"./course_landing_top_bg.svg": "./cheops/img/course_landing_top_bg.svg",
	"./couse-back-arrow.svg": "./cheops/img/couse-back-arrow.svg",
	"./cpm/sirius_courses_logo_small_white.svg": "./cheops/img/cpm/sirius_courses_logo_small_white.svg",
	"./cross.svg": "./cheops/img/cross.svg",
	"./double_frame.svg": "./cheops/img/double_frame.svg",
	"./empty.svg": "./cheops/img/empty.svg",
	"./eye.svg": "./cheops/img/eye.svg",
	"./fingerprint.svg": "./cheops/img/fingerprint.svg",
	"./footer_logo.svg": "./cheops/img/footer_logo.svg",
	"./graph_course_bg.svg": "./cheops/img/graph_course_bg.svg",
	"./graph_marker.svg": "./cheops/img/graph_marker.svg",
	"./graph_marker_autograde.svg": "./cheops/img/graph_marker_autograde.svg",
	"./graph_marker_blue.svg": "./cheops/img/graph_marker_blue.svg",
	"./graph_marker_green.svg": "./cheops/img/graph_marker_green.svg",
	"./graph_marker_orange.svg": "./cheops/img/graph_marker_orange.svg",
	"./graph_marker_purple.svg": "./cheops/img/graph_marker_purple.svg",
	"./graph_marker_red.svg": "./cheops/img/graph_marker_red.svg",
	"./graph_marker_selected.svg": "./cheops/img/graph_marker_selected.svg",
	"./graph_marker_small.svg": "./cheops/img/graph_marker_small.svg",
	"./graph_marker_small_selected.svg": "./cheops/img/graph_marker_small_selected.svg",
	"./graph_module_bg.svg": "./cheops/img/graph_module_bg.svg",
	"./how_to_module.svg": "./cheops/img/how_to_module.svg",
	"./how_to_module_editable_red.svg": "./cheops/img/how_to_module_editable_red.svg",
	"./how_to_module_editable_violet.svg": "./cheops/img/how_to_module_editable_violet.svg",
	"./how_to_module_qa.svg": "./cheops/img/how_to_module_qa.svg",
	"./how_to_module_starred.svg": "./cheops/img/how_to_module_starred.svg",
	"./how_to_module_starred_green.svg": "./cheops/img/how_to_module_starred_green.svg",
	"./how_to_module_starred_purple.svg": "./cheops/img/how_to_module_starred_purple.svg",
	"./how_to_module_success.svg": "./cheops/img/how_to_module_success.svg",
	"./how_to_module_video.svg": "./cheops/img/how_to_module_video.svg",
	"./icon_check.svg": "./cheops/img/icon_check.svg",
	"./icon_copy.svg": "./cheops/img/icon_copy.svg",
	"./icon_double_check.svg": "./cheops/img/icon_double_check.svg",
	"./icon_download.svg": "./cheops/img/icon_download.svg",
	"./icon_file.svg": "./cheops/img/icon_file.svg",
	"./icons.svg": "./cheops/img/icons.svg",
	"./icons_baloon_corner.svg": "./cheops/img/icons_baloon_corner.svg",
	"./icons_plus.svg": "./cheops/img/icons_plus.svg",
	"./icons_question.svg": "./cheops/img/icons_question.svg",
	"./landings_menu_burger.svg": "./cheops/img/landings_menu_burger.svg",
	"./landings_menu_burger_black.svg": "./cheops/img/landings_menu_burger_black.svg",
	"./lecturer-no-avatar--small.svg": "./cheops/img/lecturer-no-avatar--small.svg",
	"./lecturer_no_avatar_white.svg": "./cheops/img/lecturer_no_avatar_white.svg",
	"./lock.svg": "./cheops/img/lock.svg",
	"./menu_button.svg": "./cheops/img/menu_button.svg",
	"./menu_button_dots.svg": "./cheops/img/menu_button_dots.svg",
	"./module-list-arrow.svg": "./cheops/img/module-list-arrow.svg",
	"./module_card__no_avatar.svg": "./cheops/img/module_card__no_avatar.svg",
	"./module_card__no_lecturer.svg": "./cheops/img/module_card__no_lecturer.svg",
	"./module_card_menu_mobile.svg": "./cheops/img/module_card_menu_mobile.svg",
	"./nav_item_checkmark--double.svg": "./cheops/img/nav_item_checkmark--double.svg",
	"./nav_item_checkmark.svg": "./cheops/img/nav_item_checkmark.svg",
	"./navigation_checkmark.svg": "./cheops/img/navigation_checkmark.svg",
	"./navigation_list.svg": "./cheops/img/navigation_list.svg",
	"./navigation_pencil.svg": "./cheops/img/navigation_pencil.svg",
	"./navigation_play.svg": "./cheops/img/navigation_play.svg",
	"./navigation_star.svg": "./cheops/img/navigation_star.svg",
	"./next_task_blue.svg": "./cheops/img/next_task_blue.svg",
	"./next_task_ico.svg": "./cheops/img/next_task_ico.svg",
	"./notfifications-bell.svg": "./cheops/img/notfifications-bell.svg",
	"./notifications_bell_transparent.svg": "./cheops/img/notifications_bell_transparent.svg",
	"./ok.svg": "./cheops/img/ok.svg",
	"./parent_code_icon.svg": "./cheops/img/parent_code_icon.svg",
	"./plane-gray.svg": "./cheops/img/plane-gray.svg",
	"./plane.svg": "./cheops/img/plane.svg",
	"./plane_gray.svg": "./cheops/img/plane_gray.svg",
	"./plane_green.svg": "./cheops/img/plane_green.svg",
	"./prof_cheops_advising.svg": "./cheops/img/prof_cheops_advising.svg",
	"./prof_cheops_certificate.svg": "./cheops/img/prof_cheops_certificate.svg",
	"./prof_cheops_checkmark.svg": "./cheops/img/prof_cheops_checkmark.svg",
	"./prof_cheops_feedback.svg": "./cheops/img/prof_cheops_feedback.svg",
	"./prof_cheops_greeting.svg": "./cheops/img/prof_cheops_greeting.svg",
	"./prof_cheops_greeting_cpm.svg": "./cheops/img/prof_cheops_greeting_cpm.svg",
	"./prof_cheops_happy.svg": "./cheops/img/prof_cheops_happy.svg",
	"./prof_cheops_nothing.svg": "./cheops/img/prof_cheops_nothing.svg",
	"./prof_cheops_nothing_to_do.svg": "./cheops/img/prof_cheops_nothing_to_do.svg",
	"./progress-50.svg": "./cheops/img/progress-50.svg",
	"./progress-circle-empty.svg": "./cheops/img/progress-circle-empty.svg",
	"./progress-circle.svg": "./cheops/img/progress-circle.svg",
	"./rating_star.svg": "./cheops/img/rating_star.svg",
	"./rating_star_starred.svg": "./cheops/img/rating_star_starred.svg",
	"./safari-pinned-tab.svg": "./cheops/img/safari-pinned-tab.svg",
	"./sirius_courses_logo_small.svg": "./cheops/img/sirius_courses_logo_small.svg",
	"./sirius_courses_logo_small_white.svg": "./cheops/img/sirius_courses_logo_small_white.svg",
	"./social/dzen.svg": "./cheops/img/social/dzen.svg",
	"./social/max.svg": "./cheops/img/social/max.svg",
	"./social/telegram.svg": "./cheops/img/social/telegram.svg",
	"./social/vk.svg": "./cheops/img/social/vk.svg",
	"./social/youtube.svg": "./cheops/img/social/youtube.svg",
	"./square_cap_icon.svg": "./cheops/img/square_cap_icon.svg",
	"./star.svg": "./cheops/img/star.svg",
	"./star_o.svg": "./cheops/img/star_o.svg",
	"./verdict_bg_ok.svg": "./cheops/img/verdict_bg_ok.svg",
	"./verdict_bg_ok_first_try.svg": "./cheops/img/verdict_bg_ok_first_try.svg",
	"./verdict_bg_partly.svg": "./cheops/img/verdict_bg_partly.svg",
	"./verdict_bg_partly_can_again.svg": "./cheops/img/verdict_bg_partly_can_again.svg",
	"./verdict_bg_repeated.svg": "./cheops/img/verdict_bg_repeated.svg",
	"./verdict_bg_wrong.svg": "./cheops/img/verdict_bg_wrong.svg",
	"./verdict_bg_wrong_can_again.svg": "./cheops/img/verdict_bg_wrong_can_again.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./cheops/img sync recursive ^\\.\\/.*\\.svg$";